"use client";
import { Stack, Text, Icon, Box } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { MdOutlineDoneAll } from "@onemind-services-llc/react-icons-ng/md";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";

type DescriptionProps = {
  points: { label: string; text: string }[];
};

const Content = (props: DescriptionProps) => {
  const { points } = props;
  const textVariant = useTextVariants();
  return (
    <Stack>
      {points.map((point, i) => (
        <Box color={"text.100"} key={i}>
          <Text variant={textVariant} as="span" fontWeight={600}>
            <Box as="span" display="inline-flex" alignItems="center" mt={2} mr={2}>
              <Icon as={MdOutlineDoneAll} />
            </Box>
            {point.label} -{" "}
          </Text>
          <Text variant={textVariant} as="span">
            {point.text}
          </Text>
        </Box>
      ))}
    </Stack>
  );
};

export const SOLUTIONS_CONSTANTS = {
  title: "Onemind’s VDI Solutions – How We Help You",
  desc: "At Onemind, we offer a high-performance, cloud-hosted VDI solution powered by Inuvika OVD, designed for enterprises and ISVs. Our DaaS (Desktop-as-a-Service) solution is optimized for remote work, secure application streaming, and high-performance computing (HPC).",
  list: [
    {
      image: Img1,
      title: "Onemind’s Cloud-Hosted VDI (Powered by Inuvika OVD)",
      content: (
        <Content
          points={[
            {
              text: "Securely stream Windows & Linux applications from the cloud.",
              label: "Cloud-Hosted VDI",
            },
            {
              text: "Multi-User & Multi-Tenant Optimization – Ideal for businesses, ISVs, and SMBs.",
              label: "Optimized for Multi-Tenancy",
            },
            {
              text: "Access desktops from Windows, macOS, Linux, iOS, Android, and HTML5 browsers.",
              label: "Cross-Platform Access",
            },
            {
              text: "Multi-factor authentication, encrypted sessions, and 99.99% SLA uptime.",
              label: "Enterprise-Grade Security",
            },
            {
              text: "Optimized for Adobe, Autodesk, Dassault SolidWorks, and CAD applications.",
              label: "Pre-Validated ISV Workstations",
            },
            {
              text: "Remote teams, ISVs, educational institutions, and government agencies.",
              label: "Best For",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title:
        "Onemind’s ISV Desktops (Powered by AMD Ryzen™ and Threadripper™ Processors)",
      content: (
        <Content
          points={[
            {
              text: "Optimized for demanding workloads like AI/ML, CAD, and 3D modeling.",
              label: "High-Performance ISV Workstations",
            },
            {
              text: "AMD Ryzen™ PRO and Threadripper™ processors for peak performance.",
              label: "Enterprise-Grade Compute Power",
            },
            {
              text: "Pre-configured for Autodesk, Dassault CATIA, SolidWorks, and 3D Systems software.",
              label: "Certified for ISV Applications",
            },
            {
              text: "Supports AI inference, deep learning, and 3D simulation.",
              label: "GPU-Accelerated Performance",
            },
            {
              text: "Run multiple virtual desktops on a single high-performance workstation.",
              label: "Multi-Session Capability",
            },
            {
              text: "Engineering, architecture, AI research, and professional ISV applications.",
              label: "Best For",
            },
          ]}
        />
      ),
    },
  ],
};
